import { c as _c } from "react-compiler-runtime";
import * as React from "react";
import { Group, Text } from "react-aria-components";
import { AlertTriangle, CheckCircle, InfoCircle } from "../icons/line.js";
import { action, alerts, defaultIcon, descriptionText, dismissButton, titleText } from "./Alert.css.js";
import { Button } from "./Button.js";
import { CloseX } from "./CloseX.js";
import { Link } from "./Link.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function renderIcon(type) {
  switch (type) {
    case "info":
    case "message":
    case "error":
    case "primary":
      {
        return /*#__PURE__*/_jsx(InfoCircle, {
          className: defaultIcon({
            type,
            preset: true
          })
        });
      }
    case "warning":
      {
        return /*#__PURE__*/_jsx(AlertTriangle, {
          className: defaultIcon({
            type,
            preset: true
          })
        });
      }
    case "success":
      {
        return /*#__PURE__*/_jsx(CheckCircle, {
          className: defaultIcon({
            type,
            preset: true
          })
        });
      }
  }
}
const alertTypeToButtonColorMap = {
  info: "secondaryGray",
  message: "secondaryGray",
  primary: "primary",
  error: "alertError",
  warning: "alertWarning",
  success: "alertSuccess"
};
const alertTypeToLinkColorMap = {
  info: "gray",
  message: "gray",
  primary: "primary",
  error: "error",
  warning: "alert",
  success: "success"
};
const alertTypeToCloseVariant = {
  info: "gray",
  message: "gray",
  primary: "primary",
  error: "error",
  warning: "alert",
  success: "success"
};
const defaultAction = [];
const BaseAlert = (t0, ref) => {
  const $ = _c(28);
  const {
    type,
    title,
    description,
    onClose,
    actions: t1,
    icon: Icon
  } = t0;
  const actions = t1 === undefined ? defaultAction : t1;
  const customIconDescriptionOnly = Icon != null && description == null && actions.length === 0;
  let t2;
  if ($[0] !== type) {
    t2 = alerts({
      type
    });
    $[0] = type;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== Icon || $[3] !== customIconDescriptionOnly || $[4] !== type) {
    t3 = Icon ? /*#__PURE__*/_jsx(Group, {
      className: defaultIcon({
        type,
        descriptionOnly: customIconDescriptionOnly
      }),
      children: /*#__PURE__*/_jsx(Icon, {})
    }) : renderIcon(type);
    $[2] = Icon;
    $[3] = customIconDescriptionOnly;
    $[4] = type;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== type) {
    t4 = titleText({
      type
    });
    $[6] = type;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4 || $[9] !== title) {
    t5 = /*#__PURE__*/_jsx(Text, {
      className: t4,
      children: title
    });
    $[8] = t4;
    $[9] = title;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== onClose || $[12] !== type) {
    t6 = onClose && /*#__PURE__*/_jsx(Group, {
      className: dismissButton,
      children: /*#__PURE__*/_jsx(CloseX, {
        size: "s",
        type: "square",
        variant: alertTypeToCloseVariant[type],
        onPress: onClose
      })
    });
    $[11] = onClose;
    $[12] = type;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== description || $[15] !== type) {
    t7 = description != null && /*#__PURE__*/_jsx(Text, {
      className: descriptionText({
        type
      }),
      children: description
    });
    $[14] = description;
    $[15] = type;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== actions || $[18] !== type) {
    t8 = actions.length > 0 && /*#__PURE__*/_jsx(Group, {
      className: action,
      children: actions.map((action$0, index) => {
        switch (action$0.kind) {
          case "button":
            {
              return /*#__PURE__*/_jsx(Button, {
                size: "xs",
                hierarchy: alertTypeToButtonColorMap[type],
                onPress: action$0.onPress,
                leadingIcon: action$0.leadingIcon,
                trailingIcon: action$0.trailingIcon,
                variant: "default",
                loading: action$0.loading,
                children: action$0.displayText
              }, action$0.displayText);
            }
          case "iconOnly":
            {
              return action$0.loading === true ? /*#__PURE__*/_jsx(Button, {
                size: "xs",
                hierarchy: alertTypeToButtonColorMap[type],
                loading: true,
                variant: "iconOnly"
              }, index) : /*#__PURE__*/_jsx(Button, {
                size: "xs",
                hierarchy: alertTypeToButtonColorMap[type],
                leadingIcon: action$0.leadingIcon,
                variant: "iconOnly"
              }, index);
            }
          case "link":
            {}
          case undefined:
            {
              const {
                link,
                displayText,
                ...props
              } = action$0;
              return /*#__PURE__*/_jsx(Link, {
                size: "xs",
                href: link,
                hierarchy: alertTypeToLinkColorMap[type],
                ...props,
                children: displayText
              }, displayText);
            }
        }
      })
    });
    $[17] = actions;
    $[18] = type;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== ref || $[21] !== t2 || $[22] !== t3 || $[23] !== t5 || $[24] !== t6 || $[25] !== t7 || $[26] !== t8) {
    t9 = /*#__PURE__*/_jsxs(Group, {
      className: t2,
      ref: ref,
      children: [t3, t5, t6, t7, t8]
    });
    $[20] = ref;
    $[21] = t2;
    $[22] = t3;
    $[23] = t5;
    $[24] = t6;
    $[25] = t7;
    $[26] = t8;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  return t9;
};
export const Alert = /*#__PURE__*/React.forwardRef(BaseAlert);
//# sourceMappingURL=Alert.js.map